const structureMixin = {

    data() {
        return {
            RESOURCE_TYPES: {
                1: 'Должности E-Kyzmat',
                2: 'Локальные должности',
                4: 'Категория реестра должностей',
                3: 'Национальный резерв кадров',
            },
            structure: {
                id: this.$route.params.id,
            },
            resourceType: '',
            resources: [],
            resource: {
                id: '',
            },
            formOptions: {
                resourceTypes: [],
                testingTypes: [],
                status: [],
                positions: [],
            },
            hrm: {
                departmentId: '',
            },
            showResources: false,
            test: {
                id: '',
                testTypeId: '',
                questionCount: '',
                typeQuestionCount: '',
                duration: '',
                title: '',
                randomize: '',
                minimalPoint: '',
            },

            formHelper: {
                testTypes: [],
            },
        }
    },
    methods: {
        fetchStructure() {
            return this.axios.get(this.$config.urls.structure.fetchTestingStructure.url.replace(':id', this.structureId))
                .then(response => {
                    return this.structure = response.data.data;
                }).catch(() => {
                });
        },
        fetchFormOptions(questionCount = false, groupType = null,typeId=null) {
            let params = {};

            if (groupType)
            {
                params.groupType = groupType;
            }

            if (typeId)
            {
                params.testTypeId = typeId;
            }

            return this.axios.get(this.$config.urls.structure.fetchStructureFormOptions.url, {params: params})
                .then((response => {
                    this.formOptions.resourceTypes = response.data.data.resourceTypes;

                    if (!questionCount)
                        this.formOptions.testingTypes = response.data.data.testingTypes;
                    else
                        this.formOptions.testingTypes = response.data.data.testingTypes.map(item => {
                            item.title = item.title + ' (кол. вопросов: ' + item.questionCount + ')'
                            return item;
                        });


                    this.formOptions.status = this.objectToArray(response.data.data.status, true);

                    if (this.formHelper.testTypes.length < 1 && this.form.tests.length < 1) {

                        this.formHelper.testTypes = [...response.data.data.testingTypes];
                    }

                })).catch(() => {
                });
        },
        fetchStructureResourceOptions(params, typeId = null) {
            return this.axios.get(this.$config.urls.structure.fetchStructureResourceOptions.url, {params: params})
                .then(response => {

                    if (typeId === this.RESOURCE_NRK_ID)
                        this.resources = response.data.data.map((item => {
                            item.title = item.title + ' (' + item.resourceTitle + ')';
                            return item;
                        }));
                    else
                        this.resources = response.data.data;
                }).catch(() => {
                });
        },
        testDelete(testId) {
            this.$snotify.confirm(this.getTranslation('deleteConfirmMsg'), {
                showProgressBar: false,
                closeOnClick: false,
                backdrop: 0.5,
                buttons: [
                    {
                        text: this.getTranslation('yes'), action: (toast) => {
                            this.axios.delete(this.$config.urls.structure.fetchTest.url.replace(':id', testId)).then(() => {
                                this.fetchStructure();
                            }).then(() => {
                                this.$snotify.remove(toast.id);
                                setTimeout(() => {
                                    this.snotifySuccess('deleteSuccessMsg');
                                });
                            }).catch(() => this.$snotify.remove(toast.id));

                        }, bold: true
                    },
                    {text: this.getTranslation('no'), action: (toast) => this.$snotify.remove(toast.id)}
                ]
            });
        },
    },
    computed: {

        structureId() {
            return this.$route.params.id;
        },
    },
};

export default structureMixin;
